export function initialState() {
  return {
    loggedIn: false,
    token: null,
    user: null
  }
}

export default initialState()
